import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { getSlug } from "../../../utils";
import { Link } from "@quintype/components";
import "./collection-name.m.css";

export const CollectionNameBase = ({
  collection = {},
  config,
  pageType,
  color = "#231f20",
  borderBottomColor = "#ec2227"
}) => {
  if (Object.keys(collection).length <= 0) {
    return null;
  }
  const slug = getSlug(collection, config);
  const getData = () => (
    <div styleName="container">
      <h2 styleName="headline" className="collection-name" style={{ color: color }}>
        {collection.name}
      </h2>
      <div styleName="border" className="collection-border" style={{ borderBottomColor: borderBottomColor }} />
    </div>
  );

  return pageType !== "home-page" ? getData() : <Link href={slug}>{getData()}</Link>;
};

CollectionNameBase.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
  slug: PropTypes.string,
  pageType: PropTypes.string,
  color: PropTypes.string,
  borderBottomColor: PropTypes.string
};

function mapStateToProps(state) {
  return {
    config: get(state, ["qt", "config"], {}),
    pageType: get(state, ["qt", "pageType"], "")
  };
}

export const CollectionName = connect(mapStateToProps)(CollectionNameBase);
